var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWindows = function SvgWindows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0078D4",
    d: "M1.5 1.5h9.955v9.95H1.5zm11.045 0H22.5v9.95h-9.955zM1.5 12.545h9.955V22.5H1.5zm11.045 0H22.5V22.5h-9.955"
  })));
};
export default SvgWindows;